import { render, staticRenderFns } from "./VisaHelpModal2.vue?vue&type=template&id=180edb06&scoped=true"
import script from "./VisaHelpModal2.vue?vue&type=script&lang=js"
export * from "./VisaHelpModal2.vue?vue&type=script&lang=js"
import style0 from "./VisaHelpModal2.vue?vue&type=style&index=0&id=180edb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180edb06",
  null
  
)

export default component.exports